import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { t } from 'ember-intl';
import { eq } from 'ember-truth-helpers';
import { camelize } from 'frontend-utils/utils/convert-case';
import changeColorClass from 'lumen/helpers/change-color-class';
import {
  KPIS,
  REVENUE_INSIGHT_METRICS,
} from 'lumen/utils/constants/ri-constant-values';
import { changeValueFormat } from 'lumen/utils/revenue-insight/value-formatting';

interface HotelAndMarketRevenueInsightTablesRowsTooltipRevenueInsightDifferenceRowSignature {
  Args: {
    kpiCategory: unknown;
    kpis: unknown;
    metrics: unknown;
    tooltipValues: unknown;
  };
}

export default class HotelAndMarketRevenueInsightTablesRowsTooltipRevenueInsightDifferenceRow extends Component<HotelAndMarketRevenueInsightTablesRowsTooltipRevenueInsightDifferenceRowSignature> {
  @service declare intl: Services['intl'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get showSubtitle() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-return
    return this.args.metrics.some((metric) => metric.includes('cancellation'));
  }

  // @ts-expect-error: Incorrect type
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  getKpiKey(kpi) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return this.args.kpiCategory
      ? // eslint-disable-next-line @typescript-eslint/no-base-to-string, @typescript-eslint/restrict-template-expressions
        camelize(`${kpi}_${this.args.kpiCategory}`)
      : kpi;
  }

  @action
  // @ts-expect-error: Incorrect type
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  getAbsoluteChangeForKpi(kpi) {
    // @ts-expect-error: Incorrect type
    const metricToUse = this.args.showPickupLY
      ? REVENUE_INSIGHT_METRICS.FORECAST_REFERENCE_CHANGE
      : REVENUE_INSIGHT_METRICS.CHANGE;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const kpiKeyToUse = this.getKpiKey(kpi);

    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
    return this.args.tooltipValues[metricToUse][kpiKeyToUse];
  }

  @action
  // @ts-expect-error: Incorrect type
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  getFormattedAbsoluteChangeForKpi(kpi) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const absoluteChange = this.getAbsoluteChangeForKpi(kpi);
    const usePercentage = kpi === KPIS.OCCUPANCY;

    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    return changeValueFormat(absoluteChange, usePercentage, this.intl);
  }

  @action
  // @ts-expect-error: Incorrect type
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  getFormattedRelativeChangeForKpi(kpi) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const relativeChange = this.getRelativeChangeForKpi(kpi);

    if (relativeChange === null || Number.isNaN(relativeChange)) {
      return this.intl.t('general.missing');
    }

    return this.intl.formatNumber(relativeChange / 100, {
      style: 'percent',
      signDisplay: 'exceptZero',
    });
  }

  @action
  // @ts-expect-error: Incorrect type
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  getRelativeChangeForKpi(kpi) {
    // @ts-expect-error: Incorrect type
    const metricToUse = this.args.showPickupLY
      ? REVENUE_INSIGHT_METRICS.FORECAST_REFERENCE_RELATIVE_CHANGE
      : REVENUE_INSIGHT_METRICS.RELATIVE_CHANGE;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const kpiKeyToUse = this.getKpiKey(kpi);

    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
    return this.args.tooltipValues[metricToUse][kpiKeyToUse];
  }

  <template>
    {{! @glint-nocheck }}
    <td class="no-border" data-test-id="row-title">
      {{t "revenue_insight.difference"}}
    </td>
    <td class="no-border" data-test-id="row-subtitle">
      {{#if this.showSubtitle}}
        {{t "revenue_insight.metrics.subtitle.BOB"}}
      {{/if}}
    </td>
    {{#each @kpis as |kpi|}}
      <td
        class="text-end
          {{if (eq @kpis.length 1) 'no-border'}}
          {{changeColorClass (this.getAbsoluteChangeForKpi kpi)}}"
        data-test-id="row-value"
      >
        {{this.getFormattedAbsoluteChangeForKpi kpi}}
        ({{this.getFormattedRelativeChangeForKpi kpi}})
      </td>
    {{/each}}
  </template>
}
